import { formatBlogDate } from "../../helper/backend-methods";

const RelatedArticleCard = ({ article }) => {
  return (
    <div className="related-card">
      <div className="meta">
        <span className="meta-date">{formatBlogDate(article.CreatedOn)}</span> <p className="meta-dot"></p> <span className="meta-cate">{article.Category}</span>
      </div>
      <h4 className="article-name">{article.Title}</h4>
      <a href={`/blog/${article.Id}`} className="read-more">
        LEARN MORE
      </a>
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="rgba(38,58,131,1)">
          <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
        </svg>
      </span>
    </div>
  );
};

export default RelatedArticleCard;
